import { useEffect, useState } from "react";

import { useIntl } from "react-intl";

import { MainNavigation } from "@ps-design-system/components/Navigation";

import { LocaleUrlPrefix } from "@/i18n/i18n.types";
import { useIntlContext } from "@/i18n/IntlProvider";
import { logoutUser } from "@/services/auth.service";
import { fetchUnreadMessageCount } from "@/services/messages.service";
import { useAuthStore } from "@/store/auth.store";
import { useProfileStore } from "@/store/profile.store";
import { trackEvent } from "@/utils/analytics.utils";

import { LocaleSelector } from "./LocaleSelector";

export const AppHeader = () => {
  const intl = useIntl();
  const { locale, localeDataMap } = useIntlContext();

  const rawUrlPrefix = localeDataMap?.[locale]?.url_prefix ?? "";
  const urlPrefix = (
    rawUrlPrefix && !rawUrlPrefix.startsWith("/")
      ? `/${rawUrlPrefix}`
      : rawUrlPrefix
  ) as LocaleUrlPrefix;

  const { profile } = useProfileStore();
  const { accessToken } = useAuthStore();
  const [unreadMessageCount, setUnreadMessageCount] = useState(0);

  // Fetch unread message count when profile is available
  useEffect(() => {
    const fetchMessageCount = async () => {
      if (accessToken && profile?.SSOid) {
        try {
          const count = await fetchUnreadMessageCount(
            accessToken,
            profile.SSOid,
          );
          setUnreadMessageCount(count);
        } catch {
          // Silently fail - message count is not critical
          setUnreadMessageCount(0);
        }
      } else {
        setUnreadMessageCount(0);
      }
    };

    fetchMessageCount();
  }, [accessToken, profile?.SSOid]);

  const navAnalyticsHandler = (
    _e: React.MouseEvent<HTMLElement> | undefined,
    elementId?: string,
  ) => {
    if (elementId === "header_link_referrals") {
      trackEvent("referral clicked", {
        button: "referral",
        source: "nav",
        destination: "referrals",
      });
    }
  };

  return (
    <div className="tw-sticky tw-top-0 tw-z-40">
      <MainNavigation
        intl={intl}
        locale={locale}
        localeSelector={<LocaleSelector />}
        messageCount={unreadMessageCount}
        nuxData={profile?.uncompletedExps?.map((nuxt) => ({
          ...nuxt,
          id: nuxt._id,
        }))}
        profile={{
          isHost: profile?.is_host,
          SSOId: profile?.SSOid,
          avatarUrl: profile?.avatar_url,
        }}
        urlPrefix={urlPrefix}
        zendeskLocale={localeDataMap?.[locale]?.zendesk_url_locale}
        analyticsTrackFunction={navAnalyticsHandler}
        logOutUser={logoutUser}
        setShowSearchNav={() => {}}
        shouldSendAuthToPage={true}
      />
      {/** Search bar will go here */}
    </div>
  );
};
